import React from 'react';
import { Menu, Navigation } from 'lucide-react';
import { useTheme } from '../styles/ThemeContext';
interface TopNavProps {
  onMenuClick: () => void;
  cameraDirection?: 'N' | 'S' | 'E' | 'W' | 'NE' | 'NW' | 'SE' | 'SW';
}
export function TopNav({
  onMenuClick,
  cameraDirection = 'N'
}: TopNavProps) {
  const {
    isDark
  } = useTheme();
  // Convert direction to rotation angle
  const getRotation = (direction: string) => {
    const rotations: Record<string, number> = {
      N: 0,
      NE: 45,
      E: 90,
      SE: 135,
      S: 180,
      SW: 225,
      W: 270,
      NW: 315
    };
    return rotations[direction] || 0;
  };
  return <div className="fixed top-6 right-6 z-50 flex items-center gap-3" data-id="element-1125">
      {/* Compass Indicator */}
      <div className={`relative w-12 h-12 backdrop-blur-xl rounded-full shadow-xl flex items-center justify-center transition-all duration-300 ${isDark ? 'bg-slate-900/70 border border-white/10' : 'bg-white/70 border border-white/40'}`} data-id="element-1126">
        {/* Compass Rose Background */}
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-1127">
          <div className={`w-10 h-10 rounded-full border transition-colors duration-300 ${isDark ? 'border-white/20' : 'border-gray-300/50'}`} data-id="element-1128" />
          {/* Cardinal Direction Markers */}
          <div className={`absolute top-1 text-[8px] font-bold transition-colors duration-300 ${isDark ? 'text-white/60' : 'text-gray-600'}`} data-id="element-1129">
            N
          </div>
          <div className={`absolute bottom-1 text-[8px] font-bold transition-colors duration-300 ${isDark ? 'text-white/40' : 'text-gray-400'}`} data-id="element-1130">
            S
          </div>
          <div className={`absolute right-1 text-[8px] font-bold transition-colors duration-300 ${isDark ? 'text-white/40' : 'text-gray-400'}`} data-id="element-1131">
            E
          </div>
          <div className={`absolute left-1 text-[8px] font-bold transition-colors duration-300 ${isDark ? 'text-white/40' : 'text-gray-400'}`} data-id="element-1132">
            W
          </div>
        </div>

        {/* Rotating Needle */}
        <div className="absolute transition-transform duration-300 ease-out" style={{
        transform: `rotate(${getRotation(cameraDirection)}deg)`
      }} data-id="element-1133">
          <Navigation className={`w-5 h-5 drop-shadow-lg ${isDark ? 'text-cyan-400' : 'text-teal-600'}`} fill="currentColor" data-id="element-1134" />
        </div>

        {/* Center Dot */}
        <div className={`absolute w-1.5 h-1.5 rounded-full shadow-lg ${isDark ? 'bg-white' : 'bg-gray-800'}`} data-id="element-1135" />
      </div>

      {/* Menu Button */}
      <button onClick={onMenuClick} className={`w-12 h-12 backdrop-blur-xl rounded-full shadow-xl flex items-center justify-center transition-all duration-300 ${isDark ? 'bg-slate-900/70 border border-white/10 text-white hover:bg-slate-800/80' : 'bg-white/70 border border-white/40 text-gray-700 hover:bg-white/90'}`} aria-label="Open menu" data-id="element-1136">
        <Menu className="w-5 h-5" data-id="element-1137" />
      </button>
    </div>;
}